import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export const SEARCH_ORIGIN_QUERY_PARAM = 'origin';

export const ANALYTICS_CATEGORIES = {
  WHILE_YOU_WAIT: 'v2-while-you-wait'
};

export const ANALYTICS_CONTEXTS = {
  BIB: 'bib',
  CATALOG_SEARCH: 'catalog-search'
};

export default createReduxConstants('ANALYTICS', {
  FETCH_DATALAYER_REQUEST: null,
  FETCH_DATALAYER_SUCCESS: null,
  FETCH_DATALAYER_FAILURE: null,
  SET_CONTEXT: null
});
